export const REVIEW_STATUS = {
  AWAITING_REVIEW: 'AWAITING_REVIEW',
  APPROVED: 'APPROVED',
  CANCELLED: 'CANCELLED',
  DRAFT: 'DRAFT',
  OFFICE_FLOW_REVISION: 'OFFICE_FLOW_REVISION',
  PERSONAL_EXPENSE: 'PERSONAL_EXPENSE'
}
export const REVIEW_STATUS_LOG_CREATED = 'CREATED'
export const REVIEW_STATUS_LOG_SEND_TO_REVIEW = 'SEND_TO_REVIEW'
export const REVIEW_STATUS_LOG_UNDER_REVIEW = 'UNDER_REVIEW'

export const BULK_FUNNEL_ACTIONS = {
  APPROVE: 'APPROVE',
  REJECT: 'REJECT',
  LOCK: 'LOCK',
  UNLOCK: 'UNLOCK',
  UNREVIEW: 'UNREVIEW',
  ACCOUNT: 'ACCOUNT',
  UNACCOUNT: 'UNACCOUNT'
}
